import getABTestValue from '@/js/common/Domain/Service/getABTestValue';
import requestService from './request';

export default (tourCriteriaForTourRequest, callback) => requestService({
    cache: false,
    url: `${window.appConfig.apiGatewayUrl}/frontend/hotelOffers`,
    data: {
        ...tourCriteriaForTourRequest,
        allOffersPerHotel: 1,
        sections: ['countries', 'rooms', 'operators', 'firstPaymentDefinitions', 'cancellationPolicies'],
        abTests: getABTestValue(),
    },
}, callback);